import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { CONTROL, PRES, SPACE, TYPE } from '../chrome';
import { COPY } from '../presentationCopy';
import { PresentationSettingsState } from '../presentationSettings';
import { SIMPLE_FONTS, resolveSlideFontFamily } from '../types';
import { AdminLabeledControl } from './AdminInfoLabel';
import AdminSettingCard from './AdminSettingCard';
import AdminVisibilitySwitch from './AdminVisibilitySwitch';
import { adminFieldSx } from './adminFormSx';

interface AdminFontsSectionProps {
  draft: PresentationSettingsState;
  setDraft: React.Dispatch<React.SetStateAction<PresentationSettingsState>>;
}

const AdminFontsSection: React.FC<AdminFontsSectionProps> = ({ draft, setDraft }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: `${SPACE[4]}px`, maxWidth: 720 }}>
    {draft.fonts.map((font, index) => {
      const meta = SIMPLE_FONTS.find((item) => item.id === font.id);
      return (
        <AdminSettingCard key={font.id} title={font.label || font.id}>
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr auto' },
            gap: 2,
            alignItems: 'center',
          }}
          >
            <AdminLabeledControl label={COPY.settingsFontLabel}>
              {({ id }) => (
                <TextField
                  id={id}
                  size="small"
                  fullWidth
                  value={font.label}
                  onChange={(event) => {
                    const fonts = draft.fonts.map((item, i) => (i === index ? { ...item, label: event.target.value } : item));
                    setDraft((current) => ({ ...current, fonts }));
                  }}
                  sx={adminFieldSx()}
                />
              )}
            </AdminLabeledControl>
            <AdminVisibilitySwitch
              checked={!font.hidden}
              label={COPY.settingsFontVisible}
              onChange={(checked) => {
                const fonts = draft.fonts.map((item, i) => (i === index ? { ...item, hidden: !checked } : item));
                setDraft((current) => ({ ...current, fonts }));
              }}
            />
          </Box>
          <Box sx={{
            mt: 2,
            px: 1.5,
            py: 1.25,
            borderRadius: `${CONTROL.radius}px`,
            bgcolor: PRES.surfaceSunken,
            border: `1px solid ${PRES.borderSubtle}`,
            fontFamily: resolveSlideFontFamily(meta?.family),
            fontWeight: meta?.fontWeight || 400,
            fontSize: 22,
            color: PRES.textPrimary,
          }}
          >
            {COPY.settingsFontSample}
          </Box>
          {meta && (
            <Typography sx={{ mt: 0.75, color: PRES.textTertiary, fontFamily: TYPE.ui, ...TYPE.caption }}>
              {meta.family} · {meta.fontWeight}
            </Typography>
          )}
        </AdminSettingCard>
      );
    })}
  </Box>
);

export default AdminFontsSection;
